import { Component, Input, OnInit } from '@angular/core';
import { IBreadcrumbItem } from 'src/app/interfaces/breadcrumb/breadcrumb.interface';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
    @Input() breadcrumb: IBreadcrumbItem[];

    constructor() {}

    ngOnInit(): void {}

    getBreadcrumb() {
        return [
            {
                link: '#',
                title: 'Home',
            },
            ...this.breadcrumb,
        ];
    }
}
